import {
  Badge,
  Box,
  Button,
  CopyButton,
  Flex,
  Grid,
  LoadingOverlay,
  NumberInput,
  Popover,
  Switch,
  Text,
  Textarea,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { api } from "../../../../library/axios";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { IconCheck, IconEyeSearch, IconX } from "@tabler/icons-react";
import { MessageResponse } from "../../../../model/MessageResponse";
import { useDisclosure } from "@mantine/hooks";
import { useProductCreateStore } from "../../../../store/useProductCreateStore";
import OpenProductTab from "../../../../components/ProductTabs";
import ButtonClose from "../../../../common/ButtonClose/ButtonClose";
import { useNavigate } from "react-router-dom";

const ItemConfig = ({ id, itemcode }: any) => {
  const navigate = useNavigate();
  const dataItemBase = useProductCreateStore((state) => state.dataItemBase);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const entity = {
    itemId: id,
    itemCode: itemcode,
    fromPrice: null,
    toPrice: null,
    price: null,
    categoryIds: null,
    warrantyPeriod: null,
    note: null,
    status: true,
    linkForCustomer: null,
  };
  const form = useForm<any>({
    mode: "controlled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    transformValues: (values) => ({
      ...values,
      price: !values.price ? null : Number(values.price),
      fromPrice: !values.fromPrice ? null : Number(values.fromPrice),
      toPrice: !values.toPrice ? null : Number(values.toPrice),
      status: values.status === null ? true : values.status,
    }),
    validate: {
      categoryIds: (value) =>
        !value || value?.length === 0 ? "Danh mục không được để trống !" : null,
      fromPrice: (value, values) =>
        (value || value === 0) &&
        values?.toPrice &&
        Number(value) >= Number(values?.toPrice)
          ? "Giá từ phải bé hơn giá đến !"
          : (!value || value?.length === 0) && value !== 0
          ? "Giá từ không được để trống !"
          : Number(value) < 0
          ? "Giá không được phép âm !"
          : null,
      toPrice: (value, values) =>
        (value || value === 0) &&
        values?.fromPrice &&
        Number(value) <= Number(values?.fromPrice)
          ? "Giá đến phải lớn hơn giá từ !"
          : (!value || value?.length === 0) && value !== 0
          ? "Giá đến không được để trống !"
          : Number(value) < 0
          ? "Giá không được phép âm !"
          : null,
      warrantyPeriod: (value) =>
        !value || value?.length === 0
          ? "Thời gian bảo hành không được để trống !"
          : null,
    },
  });
  const [loadingButton, setLoadingButton] = useState<boolean>(false);

  const getEdit = async () => {
    const res = await api.get<MessageResponse<any>>(
      `/TblItemAddOn/get-detail?id=${id}`
    );

    if (res && res) {
      const result = res?.data.data;

      // Ensure numeric values are properly parsed
      if (result.price) result.price = Number(result.price);
      if (result.fromPrice) result.fromPrice = Number(result.fromPrice);
      if (result.toPrice) result.toPrice = Number(result.toPrice);

      form.setValues(result);
    }
  };

  useEffect(() => {
    getEdit();
  }, [id]);
  const handleSubmit = async (dataSubmit: any) => {
    setLoadingButton(true);
    open();
    const validation = form.validate();
    if (validation.hasErrors) {
      console.log("Form has errors:", validation.errors);
      return;
    }

    const categoryIds =
      dataSubmit.categoryIds?.length > 0 && dataSubmit.categoryIds.includes(",")
        ? dataSubmit.categoryIds
            .replace(/\s+/g, "")
            .split(",")
            .filter((id: any) => id !== "")
            .map((id: string) => Number(id))
        : [Number(dataSubmit.categoryIds)];
    const warrantyPeriod =
      dataSubmit.warrantyPeriod?.length > 0 &&
      dataSubmit.warrantyPeriod.includes(",")
        ? dataSubmit.warrantyPeriod
            .replace(/\s+/g, "")
            .split(",")
            .filter((id: any) => id !== "")
            .map((id: string) => Number(id))
        : [Number(dataSubmit.warrantyPeriod)];
    const parsedValues = {
      ...dataSubmit,
      itemId: id,
      itemCode: itemcode,
      categoryIds,
      warrantyPeriod,
    };
    const res = await api.put("/TblItemAddOn/edit", {
      ...parsedValues,
    });
    if (res && res.data.success === true) {
      NotificationExtension.Success("Thành công");
      setLoadingButton(false);
      // form.reset();
    } else {
      NotificationExtension.Fails("Thất bại");
      setLoadingButton(false);
    }
    close();
  };
  const handleDelete = async () => {
    const res = await api.post(`/TblItemAddOn/delete`, [id]);
    if (res && res.data.success === true) {
      NotificationExtension.Success("Xóa thành công");
      modals.closeAll();
    } else {
      NotificationExtension.Fails("Xóa thất bại");
    }
  };
  const onNavigateOnWeb = () => {
    window.open(`${hacomUrl}/${dataItemBase?.url}`, "_blank");
  };
  return (
    <Box className="flex-none" mx="10px" style={{ position: "relative" }}>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <Flex justify={"space-between"} align={"center"} my={10}>
        <CopyButton value={String(dataItemBase?.itemName)} timeout={2000}>
          {({ copied, copy }) => (
            <Tooltip
              label={copied ? "Đã sao chép" : "Sao chép"}
              withArrow
              position="right"
            >
              <Badge
                color={copied ? "teal" : "blue"}
                onClick={copy}
                style={{ cursor: "pointer" }}
                size="lg"
              >
                {dataItemBase?.itemName}
              </Badge>
            </Tooltip>
          )}
        </CopyButton>
      </Flex>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Grid gutter="md">
          {/* <Grid.Col span={4}>
            <TextInput
              label="Mã sản phẩm"
              placeholder="Nhập mã sản phẩm"
              {...form.getInputProps("itemCode")}
            />
          </Grid.Col> */}
          <Grid.Col span={6}>
            <NumberInput
              label="Giá từ"
              placeholder="Nhập giá thấp nhất"
              thousandSeparator=","
              {...form.getInputProps("fromPrice")}
              withAsterisk
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <NumberInput
              label="Giá đến"
              placeholder="Nhập giá cao nhất"
              thousandSeparator=","
              {...form.getInputProps("toPrice")}
              withAsterisk
            />
          </Grid.Col>
          {/* <Grid.Col span={4}>
            <NumberInput
              label="Giá gốc"
              placeholder="Nhập giá sản phẩm"
              value={
                form.values.price !== null && form.values.price !== 0.0
                  ? Number(form.values.price)
                  : undefined
              }
              onChange={(value) => form.setFieldValue("price", value)}
            />
          </Grid.Col>{" "} */}
          <Grid.Col span={4}>
            <TextInput
              label="Danh mục (ngăn cách bởi dấu phẩy)"
              placeholder="Nhập danh mục (vd: 1, 2, 3)"
              value={form.getValues().categoryIds}
              onChange={(e) => {
                const values = e.currentTarget.value;
                form.setFieldValue("categoryIds", values);

                // Validate ngay khi thay đổi giá trị
                if (values.length === 0) {
                  form.setFieldError(
                    "categoryIds",
                    "Danh mục không được để trống"
                  );
                } else {
                  form.setFieldError("categoryIds", null);
                }
              }}
              withAsterisk
              error={form.errors.categoryIds}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Thời gian bảo hành (ngăn cách bởi dấu phẩy)"
              placeholder="Nhập thời gian (vd: 0, 6, 12)"
              value={form.getValues()?.warrantyPeriod}
              onChange={(e) => {
                const values = e.currentTarget.value;
                form.setFieldValue("warrantyPeriod", values);

                if (values.length === 0) {
                  form.setFieldError(
                    "warrantyPeriod",
                    "Thời gian bảo hành không được để trống"
                  );
                } else {
                  form.setFieldError("warrantyPeriod", null);
                }
              }}
              withAsterisk
              error={form.errors.warrantyPeriod}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Link khách hàng"
              placeholder="Nhập đường dẫn cho khách"
              {...form.getInputProps("linkForCustomer")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Textarea
              label="Ghi chú"
              placeholder="Nhập ghi chú"
              styles={{
                input: {
                  height: "250px",
                },
              }}
              {...form.getInputProps("note")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <Switch
              label="Trạng thái hiển thị"
              {...form.getInputProps("status", { type: "checkbox" })}
              mt="md"
            />
          </Grid.Col>
          <Grid.Col span={8} style={{ textAlign: "right" }} mt={"lg"}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <Button
                type="button"
                color="#3598dc"
                leftSection={<IconEyeSearch size={18} />}
                onClick={() => onNavigateOnWeb()}
              >
                Xem trên web
              </Button>
              <OpenProductTab
                productId={dataItemBase?.id}
                itemCode={dataItemBase?.itemName ?? ""}
                tabToOpen="info9"
                buttonText="Mở trang tab"
              />
              <Button
                type="submit"
                loading={loadingButton}
                disabled={loadingButton}
              >
                Lưu thông tin
              </Button>
              <Popover width={300} position="top" withArrow shadow="md">
                <Popover.Target>
                  <Button color="red">Reset</Button>
                </Popover.Target>
                <Popover.Dropdown>
                  <Text>Bạn có chắc chắn muốn xóa cấu hình này không?</Text>
                  <Button
                    color="red"
                    style={{ marginLeft: 10 }}
                    mt="lg"
                    leftSection={<IconCheck size={18} />}
                    onClick={() => handleDelete()}
                  >
                    Reset
                  </Button>
                </Popover.Dropdown>
              </Popover>
              <Button
                color="red"
                onClick={() => {
                  navigate(-1);
                }}
                leftSection={<IconX size={18} />}
              >
                Đóng
              </Button>
            </div>
          </Grid.Col>
        </Grid>
      </form>
    </Box>
  );
};

export default ItemConfig;
